export const AdapterFilterOption = {
    OT: ['Code', 'Name'],
    Proveedor: ["Identificacion", "Name"],
    Anticipo: ["DatosTrabajo.Delegacion.Codigo", "DatosTrabajo.Delegacion.Delegacion", "DatosTrabajo.OT.Codigo", "DatosTrabajo.OT.OT"]
}